import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { removeExitingSession } from '../../../lib/utils';

const Redirection = () => {

  const navigate = useNavigate();

  useEffect(() => {
    const checkUser = async () => {
       removeExitingSession()
       navigate('/')
    }
    checkUser()
  }, []);
  
  return (
    <>
      {/* <CustomLogin /> */}
    </>
  );
};

export default Redirection;
